var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyProfileHolderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#2396E9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.0097 58.5924L55.641 55.4084C55.0403 55.1078 54.667 54.5038 54.667 53.8318V51.5778C54.8197 51.3911 54.9803 51.1784 55.1463 50.9438C55.9723 49.7771 56.6343 48.4784 57.1157 47.0778C58.0563 46.6464 58.667 45.7164 58.667 44.6664V41.9998C58.667 41.3578 58.427 40.7358 58.0003 40.2498V36.7038C58.0377 36.3371 58.1843 34.1544 56.6057 32.3538C55.2363 30.7918 53.0143 29.9998 50.0003 29.9998C46.9863 29.9998 44.7643 30.7918 43.395 32.3531C41.8163 34.1538 41.963 36.3371 42.0003 36.7038V40.2498C41.5737 40.7358 41.3337 41.3578 41.3337 41.9998V44.6664C41.3337 45.4778 41.7023 46.2344 42.3317 46.7391C42.9423 49.1571 44.2203 50.9791 44.667 51.5638V53.7698C44.667 54.4151 44.315 55.0071 43.749 55.3164L37.8017 58.5604C35.8677 59.6158 34.667 61.6384 34.667 63.8411V65.9998C34.667 69.1638 44.697 69.9998 50.0003 69.9998C55.3037 69.9998 65.3337 69.1638 65.3337 65.9998V63.9711C65.3337 61.6791 64.0597 59.6178 62.0097 58.5924Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 29.9998,
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyProfileHolderIcon);
export default __webpack_public_path__ + "static/media/empty_profile_holder_icon.80ba4897db68c72af29d7d6edd0e197a.svg";
export { ForwardRef as ReactComponent };